import { DefaultTheme } from 'styled-components'

export const themeV1: DefaultTheme = {
  fontFamily: "'Noto Sans KR', sans-serif, 'Roboto', sans-serif",
}

export const themeV2: DefaultTheme = {
  fontFamily: '"Pretendard", sans-serif',
}
